import { separateMoneyNumbers, toFarsiNumber } from "@utils/digits";
import classNames from "classnames";
import { FC } from "react";
import CardDivider from "./card-divider";
import ArrowLeft from "@svg/new-design/arrow-left";
import { CARD_VARIANT } from "../types";
import {
  Button,
  BUTTON_COLOR,
  BUTTON_SIZE,
  BUTTON_VARIANT,
} from "@shared/components/button";

interface Props {
  price: number | undefined;
  variant: CARD_VARIANT;
  renderSubscriptionFooter?: boolean;
}

const SubscriptionCardFooter: FC<Props> = ({
  price,
  variant,
  renderSubscriptionFooter,
}) => {
  const isGridVariant = !variant || variant === CARD_VARIANT.GRID;

  if (renderSubscriptionFooter)
    return (
      <>
        <CardDivider showDivider={isGridVariant} />
        <div className="flex justify-between w-full items-center h-fds-34 sm:h-9 -mt-px">
          <div>
            {Boolean(price) && (
              <p className="text-fds-primary title-sm md:title-lg">
                {separateMoneyNumbers(toFarsiNumber(price))}
                <span className="body-xxsm md:body-xsm text-fds-secondary mr-0.5">
                  تومان
                </span>
              </p>
            )}

            <p className="md:title-sm title-xsm text-fds-secondary">
              در خرید تکی
            </p>
          </div>
          <hr className=" h-full border-l border-fds-disable " />
          <div>
            <p className="text-fds-brand title-xsm md:title-sm">رایگان</p>
            <p className="md:title-sm title-xsm text-fds-brand">
              در طرح اشتراک
            </p>
          </div>
        </div>
      </>
    );
  const text = price ? "رایگان برای شما" : "رایگان";
  const FooterText = isGridVariant ? (
    <>
      <p className="body-sm font-medium text-fds-primary hidden lg:block">
        {text}
      </p>
      <p className="body-sm font-medium text-fds-primary lg:hidden">رایگان</p>
    </>
  ) : (
    <p className="body-sm font-medium text-fds-primary">رایگان</p>
  );

  const FooterArrowIcon = isGridVariant ? (
    <ArrowLeft className="sm:h-5 sm:w-5 h-4 w-4 hidden lg:block" />
  ) : (
    <ArrowLeft className="sm:h-5 sm:w-5 h-4 w-4" />
  );

  return (
    <>
      <CardDivider showDivider={isGridVariant} />
      <div className="flex justify-between w-full items-center h-fds-34 sm:h-9 -mt-px">
        <div
          className={classNames(
            "h-fds-30 items-center",
            "flex justify-between w-full grow "
          )}
        >
          <div className="flex items-center gap-1.5">
            {Boolean(price) && (
              <s className="text-fds-tertiary md:body-md body-xxsm">
                {separateMoneyNumbers(toFarsiNumber(price))}
              </s>
            )}
            {FooterText}
          </div>
        </div>
        <Button
          variant={BUTTON_VARIANT.TEXT_ACTION}
          color={BUTTON_COLOR.PRIMARY}
          endIcon={FooterArrowIcon}
          size={BUTTON_SIZE.SMALL}
          className="w-fit whitespace-nowrap"
        >
          شروع یادگیری
        </Button>
      </div>
    </>
  );
};

export default SubscriptionCardFooter;
